import {JsonObject, JsonProperty} from "typescript-json-serializer";

export enum PluckIndex {
    First = "first",
    Last = "last"
}

@JsonObject()
export class GeneralisationRuleConfiguration {
    @JsonProperty()
    declare period: string;

    /**
     * Aggregate data by using D3.js nesting.
     * Nesting creates n-dimensional trees out of data.
     * Rollup function is used to apply summary functions to each group of leaf elements, to build sum or mean values.
     * Date formatter is used to define the level of nesting.
     *
     * @example: Per Hour: Set fixed minutes and seconds to nest per hour [YYYY-MM-DDTHH:00:00]
     * @example: Per Day: Set fixed hours to nest per day [YYYY-MM-DDT12:00:00]
     */
    @JsonProperty()
    declare reducer: string;

    /**
     * Index to define which values have to be selected before evaluating rollup function.
     *
     * @example: On aggregated time series, there could be summarized values, e.g. 24h sum every 10 minutes.
     * (a value every 10 minutes that summarizes the values of the last 24h)
     */
    @JsonProperty()
    declare pluck: PluckIndex;

    @JsonProperty()
    declare label: string;

    /**
     * Rule to preselect data before applying the nesting/rollup
     * Useful to extract values from a already aggregated time series
     */
    @JsonProperty()
    declare preselect: GeneralisationRuleConfiguration;

    constructor() {}
}